define('gameday-index-gdtracking/GDIndexTrackingComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','gameday-index-configurator/GamedayIndexConfigurator','message-service/message-service','gameday-index-url-hasher/UrlHasher','gameday-index-enums/enums/events/LoadEvents','app-console/app-console','app-url/app-url','device/device','screen-orientation/screen-orientation','./src/OmnitureGamedayAsync','./src/OmnitureGamedaySimPage','./src/OmnitureGamedayPage','moment'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		configManager = require("gameday-index-configurator/GamedayIndexConfigurator"),
		dispatcher = require("message-service/message-service"),
		UrlHasher = require( "gameday-index-url-hasher/UrlHasher" ),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		logg = new (require("app-console/app-console"))({ns : "IDXTracking"}),
		parseUrl = require( "app-url/app-url" ),
		device   = require("device/device"),
		orientation = require("screen-orientation/screen-orientation"),
		OmnitureGamedayAsync = require( "./src/OmnitureGamedayAsync" ),
		OmnitureGamedaySimPage = require( "./src/OmnitureGamedaySimPage" ),
		OmnitureGamedayPage = require( "./src/OmnitureGamedayPage" ),
		moment = require( "moment" );

	// instance variables
	var Superclass,
		appConfig = { },
		lastGame = null,
		trackingQueue = $.Deferred(),
		dateFormatString = "MMMM D, YYYY";

	function getDevice(){
		return {
			site_formFactor : device().formFactor,
			site_orientation: orientation()
		};

	}

	function omnitureAsyncHandler(config,event){
		var trackingData = {},
			urlParams = UrlHasher.getCachedParams(),
			game = urlParams.game,
			gameState = urlParams.game_state;
		logg.debug('async',trackingData);

		if(game!==lastGame || gameState !== 'Live'){
			var isUser = lastGame!==null;
			lastGame=game;
			return omnitureSimPageHandler(config, event);
		}

		lastGame=game;

		$.extend(trackingData, config, getDevice());

		trackingQueue.done(function(){
				omnommer = new OmnitureGamedayAsync(trackingData);

			omnommer.assign();
			omnommer.fire();
		});
	}

	function omnitureAsyncScoreboardHandler(config,event){
		var trackingData = {};
		logg.debug('async sb',trackingData);

		$.extend(trackingData, config, getDevice());

		trackingQueue.done(function(){
				omnommer = new OmnitureGamedayAsync(trackingData);

			omnommer.assign();
			omnommer.fire();
		});
	}

	function omniturePageHandler(config){
		var urlParams = parseUrl().params,
			mappedParams = {
			   	vbId				: urlParams.vbId,
			   	site_affiliateId 	: urlParams.affiliateId
			},
			trackingData = {},
			deviceType = getDevice(),
			suite = deviceType.site_formFactor === "Phone" ? config.suite.mobile : config.suite.desktop;

		$.extend(trackingData, mappedParams, deviceType, config.props);

        window.s_rsid = suite;
        window.s_account = suite;

		logg.debug('page',trackingData);

		$.getScript("http://ui.bamstatic.com/bridge/core/js/mlbamscv2.js",function(){
			trackingQueue.resolve();
		});
		trackingQueue.done(function(){
			var omnommer = new OmnitureGamedayPage(trackingData);

			omnommer.assign();
			omnommer.fire();
		});
	}

	function omnitureSimPageHandler(config, event){
		var trackingData = {},
			gameState = UrlHasher.getCachedParams().game_state,
	        channel = gameState == 'Live'  ? "Gameday" : "Preview/Wrap",
	        data = GDC.getGameData().linescore,
	        names = [data.away_team_city,data.away_team_name,'at',data.home_team_city,data.home_team_name].join(' '),
	        trackingDate = moment(data.time_date).format(dateFormatString),
	        componentName = "";

	    switch(config.componentName){
	    	case "Scoring" :
	    		componentName = "Box";
	    		break;
	    	case "Game Summary":
	    		componentName = "Play By Play";
	    		break;
	    	default:
	    		componentName = config.componentName || "";
	    }

	    if(channel === "Gameday"){
	    	componentName = channel;
	    }

		$.extend(trackingData, config, getDevice(), {
			pageName: "Major League Baseball: " + channel + ": " + componentName,
			channel : channel,
			prop1 	: (!!event ? "User" : "System") + " " + componentName,
			gameday_matchup : [componentName,names,trackingDate].join(": ")
		}); 

		logg.debug('simPage',trackingData,config);

		trackingQueue.done(function(){
			var omnommer = new OmnitureGamedaySimPage(trackingData);

			omnommer.assign();
			omnommer.fire();
		});
	}

	function GDIndexTracking(compID, divID) {
		this.componentID = compID;
		this.targetDiv = divID;

		this.init();
	}


	BaseClass.spawn(GDIndexTracking).define({
		init: function() {
			logg.log(this.targetDiv);

			this.buildAppSettings();
			this.listen();
			this.initialized = true;
			this.trackPage();
			dispatcher.publish(LoadEvts.componentReady, this.componentID);
		},

		trackPage : function(){
			var conf =  configManager.getTrackingConfig();
			logg.debug(conf);
			omniturePageHandler(conf);
			// omnitureSimPageHandler(conf.props);
		},

		listen : function(){
			//First load
			dispatcher.one("GDAppTracking",function(data){
				omnitureSimPageHandler(data);
			});
			// For now, just listen to the already published event...
			dispatcher.one("responsive-gameday-ready",function(){
				dispatcher.on("GDAppTracking",omnitureAsyncHandler);
			});
			dispatcher.on("GDScoreboardTracking",omnitureAsyncScoreboardHandler);
			// dispatcher.on("GDPageTracking",omniturePageHandler);
			
		},

		buildAppSettings: function() {
			// expand / extend the appConfig obj from above
			// iterate through config objects to construct the prpper params
		}
	});

	Superclass = GDIndexTracking.superclass;
	return GDIndexTracking;
});
